<div class="col-md-4 mt-2 column_width align-items-center">
  <mat-form-field class="w-picker">
    <input [min]="final" #input2 matInput [disabled]="isEndDate" [matDatepicker]="pickerTo" (dateChange)="is_empty()"
      autocomplete="off" placeholder="To Date (Travel)" readonly [(ngModel)]="toDate"
      (ngModelChange)="toDate_event($event)" />
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
  </mat-form-field>
  <button type="button" class="close opa" (click)="reset_To()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
  <br />
  <span *ngIf="invaliddate" style="color: red;font-size: 10px">
    'To' date should be greater than 'From' date
  </span>
</div>